<template>
	<v-container>
		<v-card flat>
			<v-card-text>
				<div class="text-xs-left">
					<h2>Terms and Conditions</h2>

					<p>‘Your HR System’ operates within ‘Your HR Team Pty Ltd’ and is referred to as the ‘system’</p>

					<h2>Passwords</h2>

					<p>
						You will be required to create a password and be responsible for safeguarding this information as each account is exclusive to a specific user. You will notify us of any suspected, unauthorised miss use. You are responsible
						for all actions and losses arising from use of your account as a result of your failure to keep your information secure and confidential. Password requirements are as follows: A password that is at least 8 to 64 characters. It
						requires 3 out of 4 of lowercase, uppercase, numbers, or symbols.
					</p>

					<h2>Subscriptions</h2>

<p>You will be invoiced at the end of each month based on the number of users in that month and with ongoing payment unless you notify us of any changes to this arrangment.  
</p>
 

<h2>Other Paid Services</h2>

					<p>Other HR consulting services via Your HR Team Pty Ltd may be negotiated as a separate fee which is negotiated with you as a separate arrangement to the access to this system.</p>

					<h2>Warranty and Acknowledgements</h2>

					<p>
						You can choose to terminate your subscription to the system with no limited timeframe. We offer a 100% money back guarantee on the system for the first 365 days of membership The system will not operate on a continuous basis,
						and may be unavailable from time to time including for maintenance purposes. We reserve the right to alter, amend or cease the operation of the system without any notice Information and materials in the system may contain
						inaccuracies and errors and we expressly exclude liability for any inaccuracies or errors The system does not intend to influence your decisions regarding the managemnet of your business and you should seek advice from a
						suitably qualified adviser before making any decisions about employment law and/or other business decisions You will not use the system in any way that causes, or is likely to cause, the system to be interrupted, damaged or
						impaired in any way. You will not use or attempt to use the system for any unlawful, criminal or negligent purposes – this includes, but is not limited to, breaking passwords, social engineering, denial-of-service attacks,
						harmful and malicious destruction of data, infringing the intellectual property rights of any person, and spreading computer viruses and invading privacy.
					</p>

					<h2>Security</h2>

					<p>
						We implement significant security procedures to help protect your data from security attacks. However, you acknowledge that use involves transmission of your data over networks that are not owned, operated or controlled by us.
						We are not responsible if your data is lost, altered, intercepted or stored across such networks. We cannot guarantee your data will always be secure or that unauthorised third parties will never be able to defeat our security
						measures or those of its third party service providers.
					</p>

					<h2>Dispute Resolution</h2>

					<p>Any dispute arising is governed by and construed in accordance with all applicable laws in force in the State of Victoria, Australia.</p>
				</div>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
	export default {
		created() {
			this.$store.dispatch('setPageTitle', 'Terms of Service');
		}
	};
</script>

<style></style>
